import React, { useState } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar, Typography, IconButton, Tooltip } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import { connect } from "react-redux";
import { setLoggedOut } from "../../store/actions/loggedinActions";

import ContactUs from "../dialogs/contactUs";
import IndexCalculatorDialog from "../dialogs/indexCalculatorDialog";
import DollarExchangeDialog from "../dialogs/dollarExchangeDialog";
import VideoInfoDialog from "../dialogs/videoInfoDialog";
import logo from "../../assets/images-v2/Logo/Group 776.svg";
import homeIcon from "../../assets/images-v2/Icons/home.svg";
import contactUsIcon from "../../assets/images-v2/Icons/contactus.svg";
import indexIcon from "../../assets/images-v2/Icons/madad.svg";
import currencyIcon from "../../assets/images-v2/Icons/matah.svg";
import tutorialsIcon from "../../assets/images-v2/Icons/tutorials.svg";
import purchaseTaxIcon from "../../assets/images-v2/Icons/masrehisha.svg";
import taxAuthorityIcon from "../../assets/images-v2/Icons/rashuthamisim.svg";
import * as customColors from "../../theme/customColors";

const useStyles = makeStyles(() => ({
  root: {
    height: "52px",
    position: "relative",
    zIndex: 2
  },
  appBar: {
    backgroundColor: "#1e3d66",
    border: `1px solid ${customColors.lightGray}`,
    boxShadow: "none"
  },
  toolbar: {
    minHeight: "50px",
    padding: "0 24px"
  },
  navigationActions: {
    display: "flex",
    alignItems: "center"
  },
  iconButton: {
    color: customColors.white,
    padding: "8px"
  },
  navigationIcon: {
    display: "block",
    height: "18px",
    objectFit: "contain",
    width: "18px"
  },
  materialNavigationIcon: {
    fontSize: "18px"
  },
  navigationLink: {
    color: "inherit",
    display: "flex"
  },
  grow: {
    flexGrow: 1
  },
  userDetails: {
    alignItems: "center",
    color: customColors.white,
    display: "flex",
    whiteSpace: "nowrap"
  },
  brandCluster: {
    direction: "ltr",
    height: "132px",
    left: "50%",
    pointerEvents: "none",
    position: "absolute",
    top: "9px",
    transform: "translateX(-50%)",
    width: "180px",
    zIndex: 3
  },
  logoLink: {
    display: "block",
    height: "82px",
    left: "49px",
    pointerEvents: "auto",
    position: "absolute",
    top: 0,
    width: "82px",
    zIndex: 2,
    "&:focus-visible": {
      borderRadius: "50%",
      outline: `2px solid ${customColors.darkBlue}`,
      outlineOffset: "2px"
    }
  },
  logo: {
    display: "block",
    height: "100%",
    width: "100%"
  },
  toolAction: {
    background: "transparent",
    border: 0,
    cursor: "pointer",
    height: "40px",
    padding: 0,
    pointerEvents: "auto",
    position: "absolute",
    width: "40px",
    zIndex: 1,
    "&:focus": {
      outline: "none"
    },
    "&:focus-visible": {
      outline: `2px solid ${customColors.darkBlue}`,
      outlineOffset: "2px"
    },
    "&:hover $toolDrawer, &:focus-visible $toolDrawer": {
      maxWidth: "190px",
      opacity: 1
    }
  },
  toolIcon: {
    display: "block",
    height: "40px",
    position: "relative",
    width: "40px",
    zIndex: 2
  },
  toolDrawer: {
    alignItems: "center",
    backgroundColor: customColors.white,
    boxShadow: "0 3px 8px rgba(0, 0, 0, 0.2)",
    boxSizing: "border-box",
    color: "#1e3d66",
    display: "flex",
    fontFamily: "\"Rubik\", \"Helvetica\", \"Arial\", sans-serif",
    fontSize: "15px",
    fontWeight: 700,
    height: "34px",
    maxWidth: 0,
    opacity: 0,
    overflow: "hidden",
    position: "absolute",
    top: "3px",
    transition: "max-width 280ms ease, opacity 180ms ease",
    whiteSpace: "nowrap",
    width: "max-content",
    zIndex: 1
  },
  toolDrawerLeft: {
    borderRadius: "18px 0 0 18px",
    justifyContent: "flex-end",
    padding: "0 26px 0 15px",
    right: "20px"
  },
  toolDrawerRight: {
    borderRadius: "0 18px 18px 0",
    justifyContent: "flex-start",
    left: "20px",
    padding: "0 15px 0 26px"
  },
  toolActionBottom: {
    "&:hover $toolDrawerBottom, &:focus-visible $toolDrawerBottom": {
      maxHeight: "72px"
    }
  },
  toolDrawerBottom: {
    alignItems: "flex-end",
    borderRadius: "18px",
    height: "auto",
    justifyContent: "center",
    left: "50%",
    maxHeight: 0,
    maxWidth: "190px",
    minHeight: "34px",
    padding: "24px 15px 8px",
    top: "20px",
    transform: "translateX(-50%)",
    transition: "max-height 280ms ease, opacity 180ms ease"
  },
  toolActionTopLeft: {
    left: "0",
    top: "23px"
  },
  toolActionTopRight: {
    right: "0",
    top: "23px"
  },
  toolActionBottomLeft: {
    left: "20px",
    top: "64px"
  },
  toolActionBottomRight: {
    right: "20px",
    top: "64px"
  },
  toolActionBottomCenter: {
    left: "70px",
    top: "84px"
  },
  "@media only screen and (max-width: 600px)": {
    toolbar: {
      padding: "0 8px"
    },
    userName: {
      display: "none"
    },
    brandCluster: {
      transform: "translateX(-50%) scale(0.85)",
      transformOrigin: "top center"
    }
  }
}));

export const NavigationBar = (props) => {
  const classes = useStyles();
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const [activeToolDialog, setActiveToolDialog] = useState(null);

  const handleClickOpen = () => {
    setIsContactUsOpen(true);
  };

  const handleClose = () => {
    setIsContactUsOpen(false);
  };

  const openExternalLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar className={classes.toolbar}>
          <div className={classes.navigationActions}>
            <Tooltip title="העסקאות שלי">
              <Link className={classes.navigationLink} to="/my-deals">
                <IconButton className={classes.iconButton}>
                  <img alt="" className={classes.navigationIcon} src={homeIcon} />
                </IconButton>
              </Link>
            </Tooltip>
            <Tooltip title="צור קשר">
              <IconButton className={classes.iconButton} onClick={handleClickOpen}>
                <img alt="" className={classes.navigationIcon} src={contactUsIcon} />
              </IconButton>
            </Tooltip>
            {props.role === "admin" || props.role === "salesman" ? (
              <Tooltip title="ניהול משתמשים">
                <Link className={classes.navigationLink} to="/users-management">
                  <IconButton className={classes.iconButton}>
                    <SupervisorAccountIcon className={classes.materialNavigationIcon} />
                  </IconButton>
                </Link>
              </Tooltip>
            ) : null}
            {props.role === "admin" ? (
              <>
                <Tooltip title="עדכון מדדים">
                  <Link className={classes.navigationLink} to="/admin/update-indexes">
                    <IconButton className={classes.iconButton}>
                      <EqualizerIcon className={classes.materialNavigationIcon} />
                    </IconButton>
                  </Link>
                </Tooltip>
                <Tooltip title="ניהול מייל חידוש לקוחות">
                  <Link className={classes.navigationLink} to="/admin/manage-email-sub-renewal">
                    <IconButton className={classes.iconButton}>
                      <ContactMailIcon className={classes.materialNavigationIcon} />
                    </IconButton>
                  </Link>
                </Tooltip>
              </>
            ) : null}
          </div>
          <div className={classes.grow} />
          <div className={classes.userDetails}>
            <Typography className={classes.userName}>
              {props.fullName} - (#{props.belongToCardNum})
            </Typography>
            <Tooltip title="התנתק">
              <IconButton className={classes.iconButton} onClick={props.setLoggedOut}>
                <ExitToAppIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.brandCluster}>
        <Link aria-label="BTAX - העסקאות שלי" className={classes.logoLink} to="/my-deals">
          <img alt="" className={classes.logo} src={logo} />
        </Link>
        <button
          aria-label="מחשבון מדד"
          className={`${classes.toolAction} ${classes.toolActionTopLeft}`}
          onClick={() => setActiveToolDialog("index")}
          type="button"
        >
          <span className={`${classes.toolDrawer} ${classes.toolDrawerLeft}`}>מחשבון מדד</span>
          <img alt="" className={classes.toolIcon} src={indexIcon} />
        </button>
        <button
          aria-label="המרת מטבע חוץ"
          className={`${classes.toolAction} ${classes.toolActionTopRight}`}
          onClick={() => setActiveToolDialog("currency")}
          type="button"
        >
          <span className={`${classes.toolDrawer} ${classes.toolDrawerRight}`}>המרת מט"ח</span>
          <img alt="" className={classes.toolIcon} src={currencyIcon} />
        </button>
        <button
          aria-label="סרטוני הדרכה"
          className={`${classes.toolAction} ${classes.toolActionBottomLeft}`}
          onClick={() => setActiveToolDialog("tutorials")}
          type="button"
        >
          <span className={`${classes.toolDrawer} ${classes.toolDrawerLeft}`}>סרטוני הדרכה</span>
          <img alt="" className={classes.toolIcon} src={tutorialsIcon} />
        </button>
        <button
          aria-label="מס רכישה"
          className={`${classes.toolAction} ${classes.toolActionBottomRight}`}
          onClick={() => openExternalLink("https://www.misim.gov.il/svsimurechisha/frmFirstPage.aspx?cur=1#nbb")}
          type="button"
        >
          <span className={`${classes.toolDrawer} ${classes.toolDrawerRight}`}>מס רכישה</span>
          <img alt="" className={classes.toolIcon} src={purchaseTaxIcon} />
        </button>
        <button
          aria-label="הוראות ביצוע"
          className={`${classes.toolAction} ${classes.toolActionBottom} ${classes.toolActionBottomCenter}`}
          onClick={() => openExternalLink("https://www.gov.il/he/departments/israel_tax_authority")}
          type="button"
        >
          <span className={`${classes.toolDrawer} ${classes.toolDrawerBottom}`}>הוראות ביצוע</span>
          <img alt="" className={classes.toolIcon} src={taxAuthorityIcon} />
        </button>
      </div>
      {isContactUsOpen ? <ContactUs open onClose={handleClose} /> : null}
      {activeToolDialog === "index" ? <IndexCalculatorDialog open onClose={() => setActiveToolDialog(null)} /> : null}
      {activeToolDialog === "currency" ? <DollarExchangeDialog open onClose={() => setActiveToolDialog(null)} /> : null}
      {activeToolDialog === "tutorials" ? <VideoInfoDialog open onClose={() => setActiveToolDialog(null)} /> : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    belongToCardNum: state.loggedinReducer.belongToCardNum,
    fullName: state.loggedinReducer.fullName,
    role: state.loggedinReducer.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoggedOut: () => dispatch(setLoggedOut())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
